export default {
  updateIndicatorList (state, payload = {}) {
    state.initIndicatorList = payload
  },
  updatedBdList (state, payload = []) {
    for (let obj of payload) {
      if (!obj.fullName) {
        console.log(obj)
        obj.fullName = obj.username
      }
    }
    payload.sort(function(a, b) {
      var nameA = a.fullName.toUpperCase()
      var nameB = b.fullName.toUpperCase()
      if (nameA < nameB) {
        return -1
      }
      if (nameA > nameB) {
        return 1
      }
      return 0
    })
    state.visitedBdList = payload
  },
  // 更新拜访记录列表
  upDateVisitData (state, payload = {}) {
    const { reset, visitedListData } = payload
    if (reset) {
      state.visitedListData = visitedListData
    } else {
      state.visitedListData.list = state.visitedListData.list.concat(visitedListData.list)
      state.visitedListData.total = visitedListData.total
    }
  },
  // 更新选择的id
  updateSelectVisitedList (state, data) {
    state.selectVisitedList = data
  },
  updateaccompanyForm (state, payload) {
    state.accompanyForm = payload
  },
  updateAccompanyingBD (state, payload) {
    state.accompanyingBD = payload
  }
}
